/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation SaveSouscriptionSupportingDocumentsMutation($input: SaveSouscriptionSupportingDocuments_M_souscription_supporting_documentsInput!) {
    saveSouscriptionSupportingDocuments_M_souscription_supporting_documents(input: $input) {
      ok
      error
      
    }
  }
`;

export default mutation;
